import { useState, useEffect } from "react";
import PropTypes from "prop-types"; // For prop validation

export default function LoadingPage({ duration = 5000 }) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Timer logic for hiding spinner
    const timer = setTimeout(() => setIsLoading(false), duration);

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, [duration]);

  if (!isLoading) return null;
  return (
    <div className="w-full fixed top-0 lef-0 z-70 h-[100vh] flex justify-center items-center bg-white ">
      <div className="flex flex-col  items-center justify-center">
        <div className=" flex gap-8  justify-center items-center">
          <div className="animate h-20 w-2 animate-bounce bg-[var(--primary)] " />
          <div className="animate h-20 w-2 animate-bounce bg-orange-500 [animation-delay:.2s]" />
          <div className="animate h-20 w-2  animate-bounce bg-red-500 [animation-delay:.4s]" />
        </div>
        <div className="w-full absolute bottom-0 flex lg:px-100 px-2 justify-center py-4 border-t border-white">
          <img
            src="/assets/crafted.png"
            alt="love"
            className="lg:w-[15%] w-[50%]"
          />
        </div>
      </div>
    </div>
  );
}

LoadingPage.propTypes = {
  duration: PropTypes.number, // Duration in milliseconds
  // Add other prop types as needed

  // Logo image source
};
